<template>
    

    <div :class="'modal-card regular '+ (stepId ? 'xonboarding' : 'xregular')">
    <section class="modal-card-body">
	<div class="container page-title-container">
        <div v-if="1">
            
        <h1 class="has-text-centered title is-3">
            Choose your plan
        </h1>
        <h6 class="subtitle is-6 has-text-centered">
            <b-button @click="havePromoCode = true" type="is-ghost" icon-left="fa fa-tag" v-if="!havePromoCode">
                Have a license code?
            </b-button>
            <b-button @click="havePromoCode = false" type="is-ghost" icon-left="fa fa-tag" v-else>
                Cancel
            </b-button>
            <br>
        </h6>
        </div>
        <div v-if="havePromoCode">
            <div class="columns is-mobile">
            <div class="column is-10 is-offset-1">
		<div class="columns">
            <div class="column is-6 is-offset-3">
                <div class="has-text-centered">
                    <PromoCode :currentUser="currentUser" :productPackages="productPackages"/>
        </div>
            
                </div>
            </div>
            </div>
            </div>
            
        </div>
        
        <div class="has-text-centered">
		
        <!-- <b-field position="is-centered">
            
            

            <b-radio-button v-model="isMonthly"
                :native-value="false"
                type="is-primary is-light is-outlined">
                <span>Annualy</span>&nbsp;<b-tag type="is-primary" size="is-small">SAVE 20%</b-tag>
            </b-radio-button>

            <b-radio-button v-model="isMonthly"
                :native-value="true"
                type="is-primary is-light is-outlined">
                <span>Monthly</span>
            </b-radio-button>
            
        </b-field>
        
        <br> -->
        
        </div>
        
        
		<div class="spacer"></div>
        
        <div class="columns is-mobile">
            
            <div class="column is-10 is-offset-1">
                
		<div class="columns">
            
            <div class="tile is-ancestor">
                <div @click="selectedPlanName = 'Starter'" class="tile is-4 is-vertical is-parent">
                    
                    <div :class="'tile is-child box '+(['Free', 'Starter'].includes(selectedPlanName) ? 'selected-plan': '')">
                        <h2 class="title is-3 plan_title has-text-whitex has-text-weight-bold">
                            Starter
                        </h2>
                        <p class="subtitle is-4 has-text-weight-light">
                            Best for Individuals
                        </p>
                        <div class="features">
                            <p><i class="fa fa-check"></i> {{ starterCredits == 500 ? '2' : '5'}} projects</p>
                            <p v-if="starterCredits == 500"><i class="fa fa-check"></i> 500 records per project</p>
                            <p v-else><i class="fa fa-check"></i> 1,000 records per project</p>
                            <p><i class="fa fa-check"></i> {{ starterCredits == 500 ? '2' : '10'}} model versions per project</p>
                            <p><i class="fa fa-check"></i> Unlimited labels</p>
                            <p><i class="fa fa-check"></i> All projects API are public</p>
                            <!-- <p><i class="fa fa-check"></i> Low GPU capacity</p> -->
                            <p><i class="fa fa-check"></i> {{ starterCredits == 500 ? 'Community' : 'Standard'}} support</p>
                        </div>
                        <hr v-if="['Free', 'Starter'].includes(currentUser['plan']['name'])">
                        <b expanded class="is-light" v-if="!onboarding && ['Free', 'Starter'].includes(currentUser['plan']['name'])">
                                Current plan with {{ currentUser.creditsQuota }} credits
                        </b>
                    </div>
                
                </div>
                <div @click="selectedPlanName = 'Pro'" class="tile is-4 is-vertical is-parent">
                    
                    <div :class="'tile is-child box '+(selectedPlanName == 'Pro' ? 'selected-plan': '')">
                        <h2 class="title is-3 plan_title has-text-whitex has-text-weight-bold">
                            PRO 
                        </h2>
                        <p class="subtitle is-4 has-text-weight-light">
                            Best for Businesses
                        </p>
                        <div class="features">
                    <p><b>Everything in Starter, Plus</b></p>
                    <p><i class="fa fa-check"></i> Unlimited projects</p>
                    <p><i class="fa fa-check"></i> 10,000 records per project</p>
                    <p><i class="fa fa-check"></i> Unlimited model versions / project</p>
                    <p><i class="fa fa-check"></i> API visibility control</p>
                    <!-- <p><i class="fa fa-check"></i> Superior GPU capacity</p> -->
					<p><i class="fa fa-check"></i> Priority support</p>
				</div>
				<hr v-if="currentUser['plan']['name'] == 'Pro'">
                <b expanded class="is-light" v-if="currentUser['plan']['name'] == 'Pro'">
                    Current plan with {{ currentUser.creditsQuota }} credits
                </b>
                    </div>
                
                </div>
                <div @click="selectedPlanName = 'Enterprise'" class="tile is-4 is-vertical is-parent">
                    
                    <div :class="'tile is-child box '+(selectedPlanName == 'Enterprise' ? 'selected-plan': '')">
                        <h2 class="title is-3 plan_title has-text-whitex has-text-weight-bold">
                            Enterprise
                        </h2>
                        <p class="subtitle is-4 has-text-weight-light">
                            For Large Business
                        </p>

                        <div class="features">
                            <p><b>Everything in Pro, Plus</b></p>
                            <p><i class="fa fa-check"></i> Custom pricing</p>
                            <p><i class="fa fa-check"></i> AI & data consultancy</p>
                            <p><i class="fa fa-check"></i> Integration options</p>
                            <p><i class="fa fa-check"></i> Private models</p>
                            <!-- <p><i class="fa fa-check"></i> On demand GPU capacity</p> -->
                        </div>
                    </div>
                
                </div>
            </div>
            
		</div>
        </div></div>
        <br>
        <div class="columns is-desktop" v-if="selectedPlanName != 'Enterprise'">
            <div class="column is-10 is-offset-1">
                
                <p class="subtitle is-5 is-pulled-left">
                    <!-- You selected the <b>{{  selectedPlanName  }}</b> plan<br> -->
                    How many credits do you want to reserve every month?
                </p>

                <div class="price has-text-right">

                    <span class="is-pulled-right">
                    <h2 class="title is-3 has-text-weight-light">
                        
                        ${{ (selectedPlanName == 'Pro' ? ( isMonthly ? calcProPricing(month=true) : (calcProPricing(month=false)/12).toFixed(0) ) : ( isMonthly ? calcStarterPricing(month=true) : (calcStarterPricing(month=false)/12).toFixed(0)) ) }}
                        
                        <span class="subtitle is-4 has-text-weight-light">/mo</span>
                        &nbsp;&nbsp;
                    </h2>
                    </span>
                    <span class="is-pulled-right">
                        <h2 class="title is-3 has-text-weight-light">

                            <i class="fa fa-bolt"></i>
                            {{ (selectedPlanName == 'Pro' ? proCredits : starterCredits) }}
                            <span class="subtitle is-4 has-text-weight-light"> credits</span>
                            <span class="subtitle is-4 has-text-weight-light"></span>
                            &nbsp;&nbsp;
                        </h2>
                    </span>
                    
                </div>
            </div>
        </div>
        <div class="columns is-mobile" v-if="selectedPlanName != 'Enterprise'">
            <div class="column is-8 is-offset-2">
                <b-field>
                        <b-slider v-if="selectedPlanName == 'Pro'" 
                            @input="packageCredits"
                            v-model="proPackage" indicator :tooltip="false" 
                            :min="3" :max="6" :step="1" 
                            :custom-formatter="(val) => sliderShowCredits(val)"
                            locale="en-US" ticks></b-slider>
                        <b-slider v-if="['Free', 'Starter'].includes(selectedPlanName)" 
                            @input="packageCredits"
                            v-model="starterPackage" indicator :tooltip="false" 
                            :min="1" :max="2" :step="1" 
                            :custom-formatter="(val) => sliderShowCredits(val)"
                            locale="en-US" ticks></b-slider>
                </b-field>
            </div>
        </div>
        <div class="columns is-mobile" v-if="selectedPlanName != 'Enterprise'">
            <div class="column is-10 is-offset-1">
                <br>
                <center>
                
                <b-button @click="submit(selectedPlanName)" type="is-primary" size="is-large" v-if="['Free', 'Starter'].includes(selectedPlanName) && calcStarterPricing() == 0">
                        Continue for Free
                </b-button>
                
                <b-button @click="submit(selectedPlanName)" type="is-primary" size="is-large" v-else>
                        Proceed to Payment
                        
                </b-button>
                
                <br>
                <p class="has-text-centered">
                    ${{ (selectedPlanName == 'Pro' ? calcProPricing(month=isMonthly) : calcStarterPricing(month=isMonthly)) }}, billed {{ isMonthly ? 'monthly' : 'annually'}}
                </p>
                <p class="image is-pulled-right has-text-dark">
                Powered by
                <img style="width: 100px; height: 45px" :src="require(`@/images/stripe.png`)">
                </p>
                
                <br>
                </center>
            </div>
        </div>
        <div class="columns is-mobile" v-else-if="selectedPlanName == 'Enterprise'">
            <div class="column is-10 is-offset-1">
                <div class="price has-text-centered">
                <a href="https://calendly.com/rafael-sandroni/15min" target="_blank">
            <b-button type="is-primary" size="is-large">
                    Contact Us
            </b-button>
        </a>
        </div>
            </div>
        </div>
        
        <div class="columns is-mobile" >
            <div class="column is-10 is-offset-1">


        <div class="content">
            <h3>
                1. What are credits, and how are they used on the Metatext platform?
            </h3>
            <p>
                Credits are the unit of value on the Metatext platform and can be used for training models or making inferences. Here's how they are consumed:<br><br>
                <b-table :data="[
                    { 'id': 'Predicting 1 text', 'first_name': '1 credit', 'last_name': '1 text predicted consumes 1 credit'},
                    { 'id': 'Training with 500 records', 'first_name': '500 credits', 'last_name': '1 model version trained on 500 records consumes 500 credit'}
                ]" :columns="[
                    {
                        field: 'id',
                        label: 'Action',
                    },
                    {
                        field: 'first_name',
                        label: 'Credits required',
                    },
                    {
                        field: 'last_name',
                        label: 'Description',
                    }]"></b-table>

            </p>
            <h3>2. How can I spend my credits on?</h3>
            <p>
                Credits can be used for training models or making inferences. A credit is equal to 1 model trained or 1 text inferenced.
            </p>
            <p>
                <b>For example, with a 2000 credit package you can:</b><br>
                Train a project with 1500 records (or texts). This will cost 1500 credits and leave you with a remaining balance of 500 credits.
                <br>
                Test 10 texts using the Inference feature. This will cost 10 credits and the remaining balance will be 490.
                <br>
                Each text sent to the Inference endpoint will cost 1 credit.
            </p>
            <h3>3. Can I change my pricing plan after subscribing?</h3>
            <p>
            Yes, you can upgrade or downgrade your plan at any time based on your requirements.
            </p>
            <h3>4. Can I cancel my subscription, and what is the cancellation policy?</h3>
            <p>
            You can cancel your subscription at any time. Please refer to Metatext's terms and conditions for details on their cancellation policy.
            </p>
        </div>
        
</div></div>
        <!-- <p v-if="onboarding">
            Do you have any questions or specific needs? <a href="mailto:help@metatext.io" target="_blank">help@metatext.io</a> write a line to us.
            <br>
            To subscribe to the Starter plan, a credit card is necessary. We will not charge your card unless you explicitly request additional credits.
        </p> -->
	</div>

    

        <hr>

        <stripe-checkout
            ref="checkoutStarterRef"
            mode="subscription"
            :pk="getPublishableKey()"
            :line-items="getProductStarterItems()"
            :success-url="getProductURL()"
            :cancel-url="cancelURL"
            @loading="v => loading = v"
        />

        <stripe-checkout
            ref="checkoutProRef"
            mode="subscription"
            :pk="getPublishableKey()"
            :line-items="getProductProItems()"
            :success-url="getProductURL()"
            :cancel-url="cancelURL"
            @loading="v => loading = v"
        />

        <b-modal v-model="isModelOpenStripe">
            <div class="modal-card xhas-text-centered" style="width: auto;">
                   
                    <section class="modal-card-body">
                        
                        <p class="has-text-centered has-text-dark">
                            <b-loading :is-full-page="false" 
                            v-model="isLoading" :can-cancel="true">
                        </b-loading>
<!-- <h1 class="title is-6 has-text-centered ">
                Opening the Payment Checkout
            </h1> -->
                </p>
                <center>
            <p class="image is-pulled-right has-text-dark">
                Powered by
                <img style="width: 100px; height: 45px" :src="require(`@/images/stripe.png`)">
            </p>
        </center>
                    </section>
            </div>
    </b-modal>

    </section>
</div>
    

  </template>
  
  
  <script>
  
  import { StripeCheckout } from '@vue-stripe/vue-stripe';
  import plans from './../plans'
  import PromoCode from '@/components/PromoCode.vue'
  export default {
    props: ['currentUser', 'onboarding', 'stepId'],
    data() {
      this.baseUrl = process.env.VUE_APP_ENV_NAME != 'staging' ? 'https://app.metatext.ai' : 'https://dev-autonlp.web.app'
      this.h = 'MFiFB4mfNEXujefjJQPwbfidkdWxOYHwnPyd1blpxYHZxWjA0TDRSZGpDRzFoY0tAXXBvNX9HQGNLaEk8YUh9XXFTcnxDVTxifUtOc2M0V0thVDF9aG9pbl9ndU8wNk9gZFBUbHNKbnJVQU1SaFdfTW5fMUNQR1dUYEdLNTVKYUh2FVz10PScpJ2hsYXYnP34nYnBsYSc%2FJ0tEJyknaHBsYS'
      return {
        publishableKeyStaging: 'pk_test_51I1WaoFB4mfNEXuj0zBEfNmL9dMxXtVwyFP9gxNKvf1RNdQ4xmjlkZbpJ53JeaUQivOkwPDHWmRZHkZ4FUBRQeBN00OdMzR8q8',
        publishableKeyProd: 'pk_live_51I1WaoFB4mfNEXujvIThHMraKyBbbQn4PFoVDmf2RqwFE7koDDImJxyOXvAdssBZuTCxhn5EK3mPr4WXV0k5BZdf00rjhNTwrk',
        // this.secret = "sk_test_51I1WaoFB4mfNEXujDMY15tQRoy34svxzb8Vu0IIokKrZpqyrK6wq1u3Yv1z1QxwwPu5kHzX0g4arv3tKmLYEwHL500506ZL4qC"
        secret: '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',
        
        // this.publishableKey = 'pk_live_51I1WaoFB4mfNEXujvIThHMraKyBbbQn4PFoVDmf2RqwFE7koDDImJxyOXvAdssBZuTCxhn5EK3mPr4WXV0k5BZdf00rjhNTwrk'
        isModelOpenStripe: false,
        havePromoCode: false,
        selectedPlanName: 'Starter', 
        proPricing: 0.000925,
        starterPricing: 0.0025,
        proPackage: 6,
        starterPackage: 2,
        proCredits: 160000,
        starterCredits: 5000,
        isMonthly: false,
        selectedPlan: plans.starter,
        isLoading: false,
        stagingProductId: 'price_1Nz0DWFB4mfNEXujuosfd7WT',
        // productStarterList: {11: 'price_1NuPKAFB4mfNEXujCTMFlGc0', 18: 'price_1NuPKBFB4mfNEXujU9ImTqgq', 106: 'price_1NuPKBFB4mfNEXujzxxGkjbq', 177: 'price_1NuPKBFB4mfNEXujj1RDlQ1g'},
        // productProList: {37: 'price_1NuPK6FB4mfNEXujOBiX5HCB', 74: 'price_1NuPK7FB4mfNEXujydOpCpuz', 111: 'price_1NuPK7FB4mfNEXuj6pdGldQE', 355: 'price_1NuPK6FB4mfNEXujSmK4L1CT', 148: 'price_1NuPK8FB4mfNEXuj5koq2bMj', 185: 'price_1NuPK9FB4mfNEXujzpvq9TBD', 710: 'price_1NuPK7FB4mfNEXujhoPSkKIE', 1065: 'price_1NuPK8FB4mfNEXuj62UslnKu', 1420: 'price_1NuPK8FB4mfNEXujn5BkBmGE', 1776: 'price_1NuPK9FB4mfNEXujdrSOqbar'},
        productPackages: {
            0: 500,
            1: 2000,
            2: 5000,
            3: 20000,
            4: 40000,
            5: 80000,
            6: 160000
        },
        productStarterList: {
            "month":{
                0: 'price_1NKRsLFB4mfNEXujMuWridZa',
                1: 'price_1NwnGbFB4mfNEXujvAE7ZinE',
                2: 'price_1O2M4uFB4mfNEXujgJ031Lb6'
            },
            "year": {
                0: 'price_1NKRsLFB4mfNEXujMuWridZa',
                1: 'price_1NwnGbFB4mfNEXujUUKbxCiL',
                2: 'price_1O2M59FB4mfNEXujGTqwjSCn'
            }
        },
        productStarterPricing: {
            "month": {
                0: 0,
                1: 18,
                2: 35
            },
            "year": {
                0: 0,
                1: 172.80,
                2: 336.00,
            },
        },
        productProList: {
            "month": {
                3:  'price_1O2M7zFB4mfNEXujvhMjuLVP',
                4:  'price_1O2M8xFB4mfNEXujRwq8VLVD',
                5: 'price_1NwnGsFB4mfNEXujEESOYfcF',
                6: 'price_1O0DehFB4mfNEXujMuIObxIl'
            }, 
            "year": {
                3:  'price_1O2M8HFB4mfNEXujSC7IcnlD', 
                4:  'price_1O2M9HFB4mfNEXujBxJdA1Om',
                5: 'price_1NwnGsFB4mfNEXujsHhQdw3h',
                6: 'price_1O0DfBFB4mfNEXujONTtwiGn'
            },
        },
        productProPricing: {
            "month": {
                3: 55, 
                4: 105,
                5: 185,
                6: 295
            }, 
            "year": {
                3: 528.00, 
                4: 1008.00, 
                5: 1776.00,
                6: 2832.00
            },
        },
        productPro: [
          {
            price: 'price_1NwnGsFB4mfNEXujigy4qAri', // The id of the recurring price you created in your Stripe dashboard
            quantity: 1,
          },
        ],
        successURLFree: '/dashboard/start/classification',
        successURL: this.baseUrl+`/checkout/checkout/stripe/success?${this.h}&session_id={CHECKOUT_SESSION_ID}&o=${this.onboarding}`,
        successURLStarter: this.baseUrl+`/checkout/checkout/stripe/success?${this.h}&session_id={CHECKOUT_SESSION_ID}&p=starter&o=${this.onboarding}`,
        successURLPro: this.baseUrl+`/checkout/checkout/stripe/success?${this.h}&session_id={CHECKOUT_SESSION_ID}&p=pro&o=${this.onboarding}`,
        cancelURL: this.baseUrl+`/d/pricing/cancel?session_id={CHECKOUT_SESSION_ID}`
      };
    },
    components: {
      StripeCheckout,
      PromoCode,
    },
    methods: {
        getProductURL(){
            return this.successURL
        },
        getProductStarterURL(){
            // let price = this.calcStarterPricing()
            // let price_id = this.productStarterList[price]
            
            let url = this.successURLStarter + `&c=${this.starterCredits}`
            return url
        },
        getProductProURL(){
            let url = this.successURLPro + `&c=${this.proCredits}`
            return url
        },
        getProductStarterItems(){
            if (process.env.VUE_APP_ENV_NAME == "staging"){
                return this.getStagingPackage()
            }
            let price_id = this.productStarterList.year[this.starterPackage]
            if (this.isMonthly){
                price_id = this.productStarterList.month[this.starterPackage]
            }
            
            return [
                {
                    price: price_id,
                    quantity: 1,
                },
            ]
        },
        getStagingPackage(){
            return [
                    {
                        price: this.stagingProductId,
                        quantity: 1,
                    },
            ]
        },
        getProductProItems(){
            if (process.env.VUE_APP_ENV_NAME == "staging"){
                return this.getStagingPackage()
            }
            let price_id = this.productProList.year[this.proPackage]
            if (this.isMonthly){
                price_id = this.productProList.month[this.proPackage]
            }
            
            return [
                {
                    price: price_id,
                    quantity: 1,
                },
            ]
        },
        getPublishableKey(){
            let publishableKey = process.env.VUE_APP_ENV_NAME != 'staging' ? this.publishableKeyProd : this.publishableKeyStaging
            return publishableKey
        },
        showPeriod(){
            if (this.isMonthly){
                return "month"
            } else {
                return "year"
            }
        },
        calcStarterPricing(month=true){
            if (month){
                let price = this.productStarterPricing.month[this.starterPackage]
                return price
            } else {
                let price = this.productStarterPricing.year[this.starterPackage]
                return price
            }
        },
        calcProPricing(month=true){
            if (month){
                let price = this.productProPricing.month[this.proPackage]
                return price
            } else {
                let price = this.productProPricing.year[this.proPackage]
                return price
            }
        },
        packageCredits(){
            this.starterCredits = this.productPackages[this.starterPackage]
            this.proCredits = this.productPackages[this.proPackage]
        },
        sliderShowCredits(val){
            return this.productPackages[val]
        },
        submit (planName) {
            this.isModelOpenStripe = true
            this.isLoading = true
            let plan = planName.toLowerCase()

            let credits = plan == 'pro' ? this.proCredits : this.starterCredits

            let license = this.isMonthly ? 'monthly' : 'yearly'

            // this.baseUrl+`/account/checkout/stripe/success?${this.h}&session_id={CHECKOUT_SESSION_ID}&o=${this.onboarding}`,
            this.successURL = this.successURL + `&c=${credits}` + `&p=${plan}` + `&l=${license}`
            
            // You will be redirected to Stripe's secure checkout page
            if (plan == 'pro'){
                this.$refs.checkoutProRef.redirectToCheckout();
            } else {
                this.$refs.checkoutStarterRef.redirectToCheckout();
            }
        },
    },
    
    mounted(){
        this.selectedPlanName = this.currentUser.plan ? this.currentUser.plan.name : this.selectedPlanName
    }
  };
  </script>
  <style>

  .modal-close { mix-blend-mode: difference; }
  
.selected-plan {
      cursor: pointer;
      border: dashed 2px #3482F6;
      border-radius: 0px;
      min-height: 10em;
    
      &:hover {
        border: dashed 2px #1367e5;
      }
    }
    </style>
  